export default __webpack_public_path__ + "1bcaa0cac6437d26db54e146f5cc8e9e.png";